import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { http } from "../../utils/httpCommon";
import { useApiUrls } from "../useApiUrl";
import { safeParsePartial } from "../../utils/zodSafeParse";
import { useIsFeatureFlagEnabled } from "../../featureFlags/useIsFeatureFlagEnabled";

const unassignShipmentIdsQueryKey = (
  serviceCenterId: number,
  planDate: number
) => ["unassignedShipments", serviceCenterId, planDate];

const unassignedShipmentsResponseSchema = z.array(z.number());

export const useUnassignedShipmentIds = (
  serviceCenterId: number,
  planDate: number
) => {
  const hookUrls = useApiUrls();
  const { getUnassignedShipments } = hookUrls;
  const isSafeParseEnabled = useIsFeatureFlagEnabled(
    "operations-5864-inbound-zod-parser-client"
  );

  return useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: unassignShipmentIdsQueryKey(serviceCenterId, planDate),
    queryFn: async () => {
      const url = getUnassignedShipments(serviceCenterId, planDate);
      const { data } = await http.get(url);
      return isSafeParseEnabled
        ? safeParsePartial(
            unassignedShipmentsResponseSchema,
            data,
            "useUnassignedShipmentIds"
          )
        : unassignedShipmentsResponseSchema.parse(data);
    },
  });
};
